import { apiClient } from "./useApi"
import type { McoEndpointBuilder } from "./apiSlice"
import { ApiTag } from "./util/ApiTag"

const allRecordsTag = { type: ApiTag.Bridge, id: "ALL" } as const

const bridgeEndpoints = (build: McoEndpointBuilder) => ({
	bridgeGetRecords: build.query({
		queryFn: (_: void) => apiClient.bridge.getBridgeRecords(),
		providesTags: (result) => [
			ApiTag.Tenant,
			...(result?.map(
				(x) =>
					({ type: ApiTag.Bridge, id: x.bridgeActivityId }) as const
			) ?? []),
			allRecordsTag
		]
	}),
	bridgeDeleteAllRecords: build.mutation({
		queryFn: (_: void) => apiClient.bridge.deleteAllBridgeRecords(),
		invalidatesTags: [allRecordsTag]
	}),
	bridgeDeleteRecord: build.mutation({
		queryFn: apiClient.bridge.deleteBridgeRecord,
		invalidatesTags: (_, __, bridgeActivityId) => [
			{ type: ApiTag.Bridge, id: bridgeActivityId } as const
		]
	})
})

export default bridgeEndpoints
